import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal, TrashIcon } from "@nens/ranalib";

import { useDeletePublication } from "../../../api/delete";
import { getId } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";

export function PublicationDelete({ closePublication }: { closePublication: () => void }) {
  const intl = useIntl();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const publicationId = usePublicationStore(getId);

  const { mutate, isMutating } = useDeletePublication();

  const deletePublication = () => {
    mutate(
      { publicationId },
      {
        onSuccess: () => {
          closePublication();
          onClose();
        },
        onError: () => {
          /* Handle error if needed */
        },
      }
    );
  };

  const deletePublicationText = intl.formatMessage({
    id: "publicaton.delete_publication",
    defaultMessage: "Delete publication",
  });

  return (
    <>
      <MenuItem onClick={onOpen} icon={<TrashIcon />}>
        {deletePublicationText}
      </MenuItem>

      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={deletePublicationText}
        buttons={[
          {
            children: <FormattedMessage id="button.delete" defaultMessage="Delete" />,
            variant: "danger",
            isDisabled: isMutating,
            onClick: deletePublication,
          },
        ]}
      >
        <FormattedMessage
          id="publication.delete_are_you_sure"
          defaultMessage="Are you sure you want to delete this publication?"
        />
      </RanaModal>
    </>
  );
}
